// const baseUrl = `https://gifview-hasura.hasura.app/v1`;
const baseUrl = `https://api.gifview.com`;

const endpoint = `${baseUrl}/graphql`;

export { baseUrl, endpoint };
